if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("json");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);
        const sectionIds = new Set();

        if (this.cartNotification) {
          this.cartNotification
            .getSectionsToRender()
            .forEach((section) => sectionIds.add(section.id));
          this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems && !this.cartNotification) {
          this.cartItems
            .getSectionsToRender()
            .forEach((section) => sectionIds.add(section.section));
        }

        const rootRoute = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
        const cartAddUrl = `${rootRoute}cart/add.js`;

        config.body = formData;

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              throw new Error(parsedState.description);
            }

            if (!this.cartNotification && !this.cartItems) return parsedState;
            if (this.cartNotification && !document.documentElement.classList.contains("magic-cart-enabled")) {
              this.cartNotification.open();
            }

            const cartUrl = `${rootRoute}cart.js`;
            const sectionsUrl = `${rootRoute}?sections=${Array.from(sectionIds).join(",")}`;

            return Promise.all([
              fetch(cartUrl).then((response) => response.json()),
              fetch(sectionsUrl).then((response) => response.json()),
            ]).then(([cartState, sections]) => ({ ...cartState, sections }));
          })
          .then((parsedState) => {
            if (!parsedState) return;

            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }
            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }
            document
              .querySelector(".product-form__error-message-wrapper")
              ?.classList.add("no-js-inline");
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}
